<!--
<mat-form-field appearance="outline">
  <mat-label [innerHtml]="field.templateOptions?.label"></mat-label>
  <mat-datetimepicker-toggle [for]="thePicker" matSuffix></mat-datetimepicker-toggle>

  <mat-date-range-picker #thePicker>
    [type]="gettype()"
    [openOnFocus]="true"
    [startView]="field.templateOptions?.startView"
    [startAt]="field.templateOptions?.startAt"
    [lang]="lang"
    <mat-date-range-picker-actions>
      <button mat-button matDateRangePickerCancel>Cancel</button>
      <button mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
  <mat-error *ngIf="formControl.errors?.matDatepickerMin">
    <span [innerText]="field.templateOptions?.errorMessageMin | translate"></span>
  </mat-error>
  <mat-error *ngIf="formControl.errors?.matDatepickerMax">
    <span [innerText]="field.templateOptions?.errorMessageMax | translate"></span>
  </mat-error>
  <mat-error *ngIf="formControl.errors?.matDatepickerParse">
    <span [innerText]="'formErrors.datepicker.matDatepickerParse' | translate"></span>
  </mat-error>
  <mat-error>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
  <input
    [title]="to.label"
    matInput
    [matDatetimepicker]="thePicker"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [matDatepickerFilter]="matDatepickerFilter"
    [min]="field.templateOptions?.minDate"
    [max]="field.templateOptions?.maxDate"
    (ngModelChange)="emitChange($event)"
    (click)="thePicker.open()"
    [required]="this.templateOptions?.required === true"
    readonly
/></mat-form-field>-->
<mat-form-field appearance="outline" class="w-full">
  <mat-label [innerHtml]="field.templateOptions?.label"></mat-label>
  <!-- Material-eigener Toggle: der mat-datetimepicker-toggle (Zusatz-Lib)
         kann seit v17 nicht mehr an einen mat-date-range-picker gekoppelt
         werden (undefined-Stream in _watchStateChanges). -->
  <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
  <!-- Kein [formControl] hier: mat-date-range-input ist kein ControlValueAccessor
         (seit A21 harter NG01203-Fehler, der das Rendering abbricht). Die Formly-
         Synchronisierung laeuft in der Komponente ueber range.valueChanges. -->
  <mat-date-range-input
    [lang]="lang"
    [rangePicker]="picker"
    [formGroup]="range"
    [formlyAttributes]="field"
    [required]="this.templateOptions?.required === true"
  >
    <input
      matInput
      readonly
      matStartDate
      [(ngModel)]="startDate"
      formControlName="start"
      [placeholder]="'shared.from' | translate"
    />
    <input
      matInput
      readonly
      matEndDate
      [(ngModel)]="endDate"
      formControlName="end"
      [placeholder]="'shared.to' | translate"
    />
  </mat-date-range-input>
  <mat-date-range-picker #picker> </mat-date-range-picker>
</mat-form-field>
